module.exports = __webpack_public_path__ + "static/media/md-outlet.58d94b5d.svg";